<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-sliders-h" main="Configurações" sub="Cadastrar, alterar ou deletar Configurações" />
        <b-form>
            <input id="config-id" type="hidden" v-model="config.id" />
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Chave:" label-for="config-name">
                        <b-form-input id="config-name" type="text"
                            v-model="config.name"
                            :class="{ 'inputError': $v.config.name.$error }"
                            class="textInput"
                            @keydown.tab="$v.config.name.$touch"/>
                        <span class="error" v-if="!$v.config.name.required && $v.config.name.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.config.name.minLength && $v.config.name.$error">Precisa ter no mínimo 2 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Valor:" label-for="config-value">
                        <b-form-input id="config-value" type="text"
                            v-model="config.value"
                            :class="{ 'inputError': $v.config.value.$error }"
                            class="textInput"
                            @keydown.tab="$v.config.value.$touch"/>
                        <span class="error" v-if="!$v.config.value.required && $v.config.value.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.config.value.minLength && $v.config.value.$error">Precisa ter no mínimo 2 letras!</span>
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" class="botaoInput" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>        
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        class="botaoInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-configs" 
                class="text-center table table-sm" 
                :items="configs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadConfig(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-configs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        class="botaoInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-configs" 
                class="text-center table table-sm" 
                :items="configs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadConfig(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-configs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'configs',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            level: '',
            config: {},
            configs: [],
            fields: [
                { key: 'name', label: 'Chave', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'value', label: 'Valor', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        ...mapState(['user']),
        rows() {
            return this.configs.length
        }
    },
        validations: {
        config: {
            name: {
                required,
                minLength: minLength(2)
            },
            value: {
                required,
                minLength: minLength(2)
            }
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        loadConfigs() {
            const url = `${baseApiUrl}/backend/configs.php`
            axios.get(url).then(res => {
                this.configs = res.data
                this.exibeRodape = false
            }).catch(
                () => {
                this.exibeRodape = true
            })
        },
        reset() {
            this.config = {}
            this.loadConfigs()
            this.$v.config.$reset()
        },
        save() {
            this.$v.config.$touch()
            if(!this.$v.config.$error){
                const method = this.config.id ? 'put' : 'post'
                const id = this.config.id ? `?id=${this.config.id}` : ''
                axios[method](`${baseApiUrl}/backend/configs.php${id}`, this.config)
                    .then(() => {
                        if (method == 'post'){
                            this.$toasted.global.defaultSuccess({ message : 'Configuração inserida com sucesso!' })
                        } else {
                            this.$toasted.global.defaultSuccess({ message : 'Configuração alterada com sucesso!' })
                        }
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(config) {
            const sure = confirm("Deseja realmente excluir a configuração?")
            if(sure === true){
                if(config.name === 'SystemTitle') {
                    this.$toasted.global.defaultError({ message : 'Item não passível de exclusão!' })
                } else if(config.name === 'PrefixTrack') {
                    this.$toasted.global.defaultError({ message : 'Item não passível de exclusão!' })
                } else if(config.name === 'SufixTrack') {
                    this.$toasted.global.defaultError({ message : 'Item não passível de exclusão!' })
                } else if(config.name === 'CurrTrack') {
                    this.$toasted.global.defaultError({ message : 'Item não passível de exclusão!' })
                } else if(config.name === 'InitTrack') {
                    this.$toasted.global.defaultError({ message : 'Item não passível de exclusão!' })
                } else {
                    const url = `${baseApiUrl}/backend/configs.php`
                    axios.delete(url, { data: config })
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Configuração excluída com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                }
            }
        },
        loadConfig(config) {
            this.config = { ...config }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        } else if (this.level === 'motorista') {
            this.$router.push('/')
        }
        this.loadConfigs()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.configs.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.textInput {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.btn-size {
    width: 30px;
    height: 30px;
    border-radius: 0;
}

.text-custom {
    font-size: 0.8rem;
}

.actionsTabela {
    max-width: 30px;
    vertical-align: middle;
}

.fieldsTabela {
    vertical-align: middle !important;
    font-size: 0.8rem;
}

.tituloTabela {
    font-weight: normal;
    font-style: italic;
    font-size: 0.9rem;
}

label {
    font-size: 0.8rem;
}
</style>